import React, { Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import Loading from "./components/Loading"
//import App from './App';
//import './index.css';
const container = document.getElementById('root');
//const root = createRoot(container);
const App = lazy(() => import('./App'));



// Detectar bots por User-Agent
const isBot = /Facebot|facebookexternalhit|Googlebot|Twitterbot/i.test(navigator.userAgent);
// Señal para react-snap
window.snapReady = false;



if (!isBot) {
  // Solo hidratar si NO es bot
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <Suspense fallback={<Loading />}>
        <App />
      </Suspense>
    </React.StrictMode>
  );
  // Cuando React ya montó, marcás listo
  window.snapReady = true;

} else {
  // Si es bot, no hidratar → se queda con el HTML prerenderizado
  console.log("Bot detectado, no se hidrata React.");
}

/*
root.render(
  <React.StrictMode>
    <Suspense fallback={<Loading />}>
      <App />
    </Suspense>
  </React.StrictMode>
);
*/